import { combineEpics } from 'redux-observable';

import trackInactivityEpic from './trackInactivity.epic';

export default combineEpics(trackInactivityEpic);
